import React, { useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Row, Col, Card, CardHeader, CardBody, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import { getColor } from '../../utils/colors';
import { getBrowniteStats } from '../../redux/actions';

const PollingMonitor = () => {
  const brownites = useSelector(state => state.stats.brownites);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBrowniteStats());
  }, [dispatch]);

  const isFetched = brownites && Object.keys(brownites).length > 0;

  // Helper to generate chart data for a department
  const genDepartmentChartData = (setsData) => {
    if (!setsData || setsData.length === 0) return 'null';

    // Check if there are any registered voters at all in this department
    const totalRegistered = setsData.reduce((acc, curr) => acc + curr.total, 0);
    if (totalRegistered === 0) return 'null';

    const labels = setsData.map(s => `SET ${s.set}`);
    const data = setsData.map(s => s.total);

    // Generate colors dynamically
    const backgroundColors = [
      getColor('primary'),
      getColor('secondary'),
      getColor('success'),
      getColor('info'),
      getColor('danger'),
      getColor('warning'),
      getColor('dark'),
    ];

    return {
      datasets: [
        {
          data: data,
          backgroundColor: backgroundColors.slice(0, data.length),
          label: 'Registered Voters',
        },
      ],
      labels: labels,
    };
  };

  return (
    <div>
      <Row>
        {isFetched ? (
          Object.entries(brownites).map(([department, setsData]) => (
            <Col xl={6} lg={12} md={12} key={department}>
              <Card className="m-2 m-sm-3 m-md-4">
                <CardHeader>Registered voters [{department}]</CardHeader>
                <CardBody>
                  {genDepartmentChartData(setsData) === 'null' ? (
                    <h5>NONE REGISTERED</h5>
                  ) : (
                    <Doughnut data={genDepartmentChartData(setsData)} />
                  )}
                </CardBody>
              </Card>
            </Col>
          ))
        ) : (
          <Col className="text-center p-5">
            <Spinner />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default PollingMonitor;
